import { createRouter, createWebHistory } from 'vue-router';
import LoginRoute from '@/modules/login/routes';
import setTitle from '@/modules/core/utils/setTitle';
import requiresAuth from '@/modules/core/security/requiresAuth';
import hasPermission from '@/modules/core/security/hasPermission';
import VisionOneRoute from '@/modules/dashboards/visionone/routes';
import VisionTwoRoute from '@/modules/dashboards/visiontwo/routes';
import VisionThreeRoute from '@/modules/dashboards/visionthree/routes';
import VisionFourRoute from '@/modules/dashboards/visionfour/routes';
import VisionFiveRoute from '@/modules/dashboards/visionfive/routes';
import EmpresasRoute from '@/modules/admin/empresas/routes';
import AssinaturasRoute from '@/modules/admin/assinaturas/routes';
import UsuariosRoute from '@/modules/admin/usuarios/routes';
import FeedbackRoute from '@/modules/admin/feedback/routes';
import ParceiroRoute from '@/modules/admin/parceiro/routes';
import EstatisticaRoute from '@/modules/admin/estatisticas/routes';
import ClientesRoute from '@/modules/dashboards/Clientes/routes';
import ReceitasRoute from '@/modules/admin/receitas/routes';
import ComissaoRoute from '@/modules/admin/comissao/routes';
import NotificacaoRoute from '@/modules/admin/notificacao/routes';
import ExPagantesRoute from '@/modules/admin/ex_pagantes/routes';
import LogsRoute from '@/modules/admin/logs/routes';
import StripeRoute from '@/modules/dashboards/stripe/routes';
import { getTipoUsuario } from './modules/shared/storage';
import { TipoUsuario } from './modules/shared/tipoUsuario';
import ListagemOSRoute from './modules/dashboards/listagemOS/routes';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [LoginRoute],
});

const rotasUsuarios = {
  [TipoUsuario.ADMIN]: {
    routes: [
      EmpresasRoute,
      AssinaturasRoute,
      UsuariosRoute,
      FeedbackRoute,
      ParceiroRoute,
      ReceitasRoute,
      ComissaoRoute,
      EstatisticaRoute,
      NotificacaoRoute,
      ExPagantesRoute,
      LogsRoute,
    ],
    redirect: '/admin/empresas',
  },
  [TipoUsuario.COMUM]: {
    routes: [
      VisionOneRoute,
      VisionTwoRoute,
      VisionThreeRoute,
      VisionFourRoute,
      VisionFiveRoute,
      ClientesRoute,
      StripeRoute,
      ListagemOSRoute,
    ],
    redirect: '/dashboards/visionone',
  },
  [TipoUsuario.SUPORTE]: {
    routes: [EmpresasRoute, UsuariosRoute, FeedbackRoute, LogsRoute],
    redirect: '/admin/empresas',
  },
};

router.rotasUsuarios = rotasUsuarios;

let rotasAdicionadas = false;

const adicionarRotas = (listaRotas) => {
  if (router.hasRoute('catchAll')) {
    router.removeRoute('catchAll');
  }

  listaRotas.routes.forEach((route) => {
    if (!router.hasRoute(route.name)) {
      router.addRoute(route);
    }
  });

  router.addRoute({
    path: '/:catchAll(.*)',
    name: 'catchAll',
    redirect: listaRotas.redirect,
  });

  rotasAdicionadas = true;
};

router.beforeEach((to) => {
  const tipoUsuario = getTipoUsuario();

  if (tipoUsuario !== null && !rotasAdicionadas) {
    adicionarRotas(rotasUsuarios[tipoUsuario]);
    return to.fullPath;
  }

  if (to.name === 'Logout') return true;
  if (!requiresAuth(to) || hasPermission(to)) return true;
  return { path: '/', query: { redirect: to.fullPath } };
});

router.afterEach((to) => { setTitle(to.name); });

export default router;
